import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import wifi from './images/wifi.svg';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {goToNextPageAsync} from '../../ServiceAppointmentAsyncthunk';

const ProgressBar = (props) => {
  const [progress, setProgress] = useState(0);
  const [remainingTime, setRemainingTime] = useState(props.resetTimeBezeq);
  const [isStartTimer, setIsStartTimer] = useState(false);

  let title = null;
  let subTitle = null;
  let isBar = false;
  let btnText = 'המשך';
  let isBtn = false;
  let imgUrl = '';
  let isTimer = '';

  useEffect(() => {
    let interval;
    if (isStartTimer) {
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress == 100) {
            clearInterval(interval);
            props.goToNextPageAsync();
            return 100;
          } else if (prevProgress == 100 / 2) {
            props.goToNextPageAsync();
          }
          return prevProgress + 100 / props.resetTimeBezeq;
        });
        setRemainingTime((prevTime) => Math.max(prevTime - 1, 0)); //update remainingTime
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isStartTimer, props.typePage, props.resetTimeBezeq]);

  const handleOnContinue = async () => {
    await props.goToNextPageAsync();
    setIsStartTimer(true);
  };

  switch (props.typePage) {
    case 'RESET_COMMUNICATION_BEZEQ_9_2_1':
      title = <>התקשורת בסיב אינה תקינה</>;
      subTitle = (
        <>
          נרצה להמשיך לאיפוס התקשורת,<br/> התהליך לוקח כ-<span>{props.resetTimeBezeq}</span> שניות
        </>
      );
      btnText = 'המשך';
      isBtn = true;
      isBar = false;
      break;
    case '1/2_RESETTING_IS_PROGRESS_9_2_2':
      title = <>שלב 1 - מתבצע איפוס תקשורת</>;
      isTimer = true;
      isBar = true;
      break;
    case '2/2_RESETTING_IS_PROGRESS_9_2_2':
      title = <>שלב 2 - מתבצעת בדיקת עוצמות חוזרת</>;
      isTimer = true;
      isBar = true;
      break;
  }

  return (
    <div className={`progress-bar-page page-wrapper`}>
      <div className='content'>
        <Image src={wifi} alt='image' />
        {title && <div className='progress-bar-title'>{title}</div>}
        {subTitle && <div className='progress-bar-sub-title'>{subTitle}</div>}
        {isTimer && (
          <div className='progress-bar-text'>
            נותרו <span>{remainingTime} </span> שניות
          </div>
        )}
        {isBar && (
          <div className='progress-bar-background'>
            <div className='progress-bar' style={{width: `${progress}%`}}></div>
          </div>
        )}
      </div>
      {isBtn && (
        <div className='button-wrapper'>
          <BtnSubmit
            className='btn-submit-purple'
            isBusiness={false}
            text={btnText}
            onclick={() => handleOnContinue()}
            formid='error-page'
            isDisplayArrows={false}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    typePage: state.serviceAppointmentSchedulerBlock.typePage,
    resetTimeBezeq: state.serviceAppointmentSchedulerBlock.dataEpi.resetTimeBezeq,
  };
};

const mapDispatchToProps = {
  goToNextPageAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar);
